
const getDomain = () => {
    var domain = "";//获取一级域名(domain=.kuaikanmanhua.com;)
    if(/\.com|\.cn/.test(location.hostname)) {
        domain = "domain=."+location.hostname.split(".").slice(-2).join(".")+";";
    }
    return domain;
};

export const setCookie = (name,value) => {
    var domain = getDomain();
    var Days = 15;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days*24*60*60*1000);
    var cookie = name + "="+ encodeURIComponent(decodeURIComponent(value)) + ";"+ domain +"path=/;expires=" + exp.toGMTString()+"";
    document.cookie = cookie;
};

export const getCookie = (name) => {//获取cookie
    var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    var arr = document.cookie.match(reg);
    if(arr){
        return decodeURIComponent(arr[2]);
    }else{
        return "";
    }
};

export const delCookie = (name) => {//删除cookie
    var domain = getDomain();
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var value = getCookie(name);
    document.cookie = name + "="+encodeURIComponent(value)+";"+ domain +"path=/;expires="+exp.toGMTString()+"";
};


// WEBPACK FOOTER //
// ./src/assets/fe_js/common/base/fn/cookie.js